import mixins from 'vue-typed-mixins';

import 勘定科目カテゴリComponentMixin from '@/entries/user/mixins/勘定科目カテゴリComponentMixin';

export default mixins(勘定科目カテゴリComponentMixin).extend({
  name: 'C勘定科目TableHeader',
});
